var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChessBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "196.011 660.755 202.4 80.3119",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsvectornator: "http://vectornator.io",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chess-Board",
    vectornatorlayername: "Chess Board"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.011 718.353L394.411 718.353L394.411 737.067L200.011 737.067L200.011 718.353Z",
    fill: "#ae765f",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.489 697.338L255.478 697.365L255.431 704.221L261.235 704.314L261.249 699.754L265.164 699.816L265.11 704.442L270.361 704.538L270.328 709.374L265.177 709.447L265.15 713.424L261.173 713.343L261.201 709.258L255.397 709.326L255.362 714.757L250.447 714.723C250.447 714.723 243.823 710.619 232.544 710.542C227.113 710.506 222.667 713.17 219.243 714.027C215.555 714.95 212.98 714.195 212.98 714.195L213.559 697.215C213.559 697.215 215.628 696.714 219.981 697.875C223.196 698.733 227.898 701.34 232.69 701.372C243.969 701.449 251.489 697.338 251.489 697.338Z",
    fill: "#cd924e",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "#0d0e1f",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.177 680.566L289.251 675.102C289.251 675.102 290.986 673.807 290.92 671.224C290.854 668.641 288.229 666.017 288.229 666.017L294.196 666.171L295.814 662.265L298.73 662.294L299.984 666.221L305.476 666.203C305.476 666.203 303.248 669.344 302.974 671.494C302.7 673.644 304.327 675.03 304.327 675.03L305.374 680.586C305.374 680.586 301.247 686.662 301.132 697.028C301.077 702.02 303.981 706.035 304.827 709.185C305.737 712.577 305.476 715.12 305.476 715.12L288.491 715.07C288.491 715.07 288.254 712.429 289.222 708.433C290.16 704.563 292.233 701.386 292.282 696.981C292.371 688.92 289.713 683.424 288.668 681.43C288.37 680.86 288.177 680.566 288.177 680.566Z",
    fill: "#cd924e",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "#0d0e1f",
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.461 699.679L223.461 711.722",
    fill: "#cd9c60",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "#0d0e1f",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.869 680.327L304.7 680.492",
    fill: "#cd9c60",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "#0d0e1f",
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.55 675.647L289.608 675.499",
    fill: "#cd9c60",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "#0d0e1f",
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.695 706.452L303.402 706.536",
    fill: "none",
    opacity: 1,
    stroke: "#0d0e1f",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.33 700.397L248.33 704.988L248.33 712.44",
    fill: "#cd9c60",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "#0d0e1f",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.911 723.592L390.47 722.781",
    fill: "#cd9c60",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "#fff9f9",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.011 718.353L394.411 718.353L394.411 737.067L200.011 737.067L200.011 718.353Z",
    fill: "none",
    opacity: 1,
    stroke: "#0d0e1f",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChessBoard);
export default __webpack_public_path__ + "static/media/ChessBoard.9ca625f27771969c04ece8824e446759.svg";
export { ForwardRef as ReactComponent };